export const History = () => {
    return <div>History</div>
}